module.exports = __webpack_public_path__ + "img/Weapon_122.69bc3fbd.png";